import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { defaultBarChartWidgetData } from "./DefaultBarChartWidgetData";
import BarWidget from "../BarWidget/BarWidget";

const BarChartWidget = ({ endpoint, datasource, requestHandler, title, subtitle, filter, profileId, solutionId,
  widgetClassName, chartClassName, options = {}, printOptions = null, locale = navigator.language, showTitle = true, showSubtitle=true,
  disableRls=false, printWidget = false, verticalOrientation= false, passedItems = null, altLabelsCheck }) => {

  const [data, setData] = useState(defaultBarChartWidgetData);
  const [error, setError] = useState("");

  useEffect(() => {
    if(!passedItems)
    requestHandler(endpoint, datasource, filter, profileId, solutionId, setData, setError, disableRls, "BAR_CHART");
  }, [endpoint, datasource, requestHandler, filter, profileId, solutionId, disableRls]);

  let newWidgetClassName="shadow-sm " + widgetClassName

  return (
    <>
    { printWidget &&
      <Card border="light" className={`${newWidgetClassName} widget-hidden`}>
        <BarWidget
          title={title}
          subtitle={subtitle}
          chartClassName={chartClassName}
          options={printOptions ? printOptions : options}
          locale={locale}
          showTitle={showTitle}
          showSubtitle={showSubtitle}
          error={error}
          data={passedItems ? passedItems : data}
          verticalOrientation={verticalOrientation}
          altLabelsCheck={altLabelsCheck}
        />
      </Card >
    }
    <Card border="light" className={`${newWidgetClassName} widget-on`}>
      <BarWidget
        title={title}
        subtitle={subtitle}
        chartClassName={chartClassName}
        options={options}
        locale={locale}
        showTitle={showTitle}
        showSubtitle={showSubtitle}
        error={error}
        data={passedItems ? passedItems : data}
        verticalOrientation={verticalOrientation} 
        altLabelsCheck={altLabelsCheck}    
      />
    </Card >
    </>
    );
  };

export default BarChartWidget;